module.exports = __webpack_public_path__ + "media/images/MR_info-350e2760.png";